import { object, func } from 'prop-types'
import isEmpty from 'lodash/isEmpty'
import isNil from 'lodash/isNil'


import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import interceptUpdater from 'coact-utils/interceptUpdater'


import HeadEditorView from './HeadEditor'

const isBlank = function (value) {
  return value === undefined || value === '' || value === null
}

const stringToLength = (value, len, ch) => {
  const lenth = parseInt(len, 10)
  let character = ch
  if (ch === undefined) character = ' '

  let i
  let str = value
  for (i = str.length; i < len; i++) {
    str = character + str
  }
  return str.slice(0, lenth)
}

const toLen = (num, len, ch) => {
  const str = `${''}${num}`
  return stringToLength(str, len, ch)
}

const diopterToDegree = function (value) {
  const floatValue = parseFloat(value)
  if (isNaN(floatValue)) return ''
  if (floatValue > 0 && floatValue < 1) return `+${toLen(parseInt(floatValue * 100, 10), 3, '0')}`
  else if (floatValue >= 1) return `+${parseInt(floatValue * 100, 10)}`
  else if (floatValue < 0 && floatValue > -1) {
    return `-${toLen(parseInt(floatValue * -100, 10), 3, '0')}`
  } else if (floatValue <= -1) return `-${parseInt(floatValue * -100, 10)}`
  else if (floatValue === 0) return '+000'
  return floatValue
}


const HeadEditor = scope(
  consumeProps({
    value: object,
    onChange: func.isRequired,
  }),

  interceptUpdater('onChange', () => (value, oldValue) => {
    const {
      brandRef: brandRefOrigin,
      seriesRef: seriesRefOrigin,
      replacementFrequency: replacementFrequencyOrigin,
      radius: radiusOrigin,
      packingQuantity: packingQuantityOrigin,
      lensColor: lensColorOrigin,
      sphereMax: SMaxOrigin,
      sphereMin: SMinOrigin,
      cylinderMax: CMaxOrigin,
      SCMax: SCMaxOrigin,
      SCMin: SCMinOrigin,
      axisMax: AMaxOrigin,
      addMax: ADDMaxOrigin,
    } = value
    const {
      brandRef: oldBrandRefOrigin,
      seriesRef: oldSeriesRefOrigin,
      replacementFrequency: oldReplacementFrequencyOrigin,
      radius: oldRadiusOrigin,
      packingQuantity: oldPackingQuantityOrigin,
      lensColor: oldLensColorOrigin,
      sphereMax: oldSMaxOrigin,
      sphereMin: oldSMinOrigin,
      cylinderMax: oldCMaxOrigin,
      SCMax: oldSCMaxOrigin,
      SCMin: oldSCMinOrigin,
      axisMax: oldAMaxOrigin,
      addMax: oldADDMaxOrigin,
    } = oldValue

    const brandRef = brandRefOrigin || { }
    const seriesRef = seriesRefOrigin || { }
    const replacementFrequency = replacementFrequencyOrigin || ''
    const radius = radiusOrigin || ''
    const packingQuantity = packingQuantityOrigin || ''
    const lensColor = lensColorOrigin || ''
    const SMax = diopterToDegree(SMaxOrigin || '')
    const SMin = diopterToDegree(SMinOrigin || '')
    const CMax = diopterToDegree(CMaxOrigin || '')
    const SCMax = diopterToDegree(SCMaxOrigin || '')
    const SCMin = diopterToDegree(SCMinOrigin || '')
    const axisMax = diopterToDegree(AMaxOrigin || '')
    const addMax = diopterToDegree(ADDMaxOrigin || '')

    const replacementFrequencyToName = {
      1: '日拋',
      14: '雙週拋',
      30: '月拋',
      60: '雙月拋',
      90: '季拋',
      365: '年拋',
    }

    const replacementFrequencyString = isNil(replacementFrequency) ?
      null :
      replacementFrequencyToName[replacementFrequency.toString()]


    const brandRefKey = isEmpty(brandRef) ? '' : brandRef.key
    const brandName = (brandRefKey.split('-')[1]) ? brandRefKey.split('-')[1] : ''
    const seriesRefKey = isEmpty(seriesRef) ? '' : seriesRef.key


    let generatedName = [
      brandName,
      seriesRefKey,
      replacementFrequencyString,
      radius,
      `${packingQuantity}片裝`,
      lensColor,
    ].join('-')

    if (SMax !== '') generatedName += ` S${SMax}`
    if (SMin !== '' && SMax !== SMin) generatedName += `${SMin}`
    if (CMax !== '') generatedName += ` C${CMax}`
    if (SCMax !== '') generatedName += ` S+C${SCMax}`
    if (SCMin !== '') generatedName += `${SCMin}`
    if (!isBlank(axisMax)) generatedName += ` A${axisMax}`
    if (!isBlank(addMax)) generatedName += ` ${addMax}`

    const brandRefRelated = (brandRefOrigin !== oldBrandRefOrigin) ? {
      brandCode: brandRef && brandRef.brandCode,
      name: brandRef && generatedName,
    } : { }

    const nameRelated = (
        (seriesRefOrigin !== oldSeriesRefOrigin) ||
        (replacementFrequencyOrigin !== oldReplacementFrequencyOrigin) ||
        (radiusOrigin !== oldRadiusOrigin) ||
        (packingQuantityOrigin !== oldPackingQuantityOrigin) ||
        (lensColorOrigin !== oldLensColorOrigin) ||
        (SMaxOrigin !== oldSMaxOrigin) ||
        (SMinOrigin !== oldSMinOrigin) ||
        (CMaxOrigin !== oldCMaxOrigin) ||
        (SCMaxOrigin !== oldSCMaxOrigin) ||
        (SCMinOrigin !== oldSCMinOrigin) ||
        (AMaxOrigin !== oldAMaxOrigin) ||
        (ADDMaxOrigin !== oldADDMaxOrigin)
      ) ? {
        name: generatedName,
      } : { }

    return {
      ...value,
      ...brandRefRelated,
      ...nameRelated,
    }
  }),

  exposeProps([
    'value',
    'onChange',
  ]),
)(HeadEditorView)

HeadEditor.displayName = 'HeadEditor'

export default HeadEditor



// WEBPACK FOOTER //
// ./src/components/products/productsC/HeadEditor/index.js